// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2ll_0","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3fM7A","obliqueLine":"membershipbadge_obliqueLine__G1KKn"};